import { FeatureFlag } from '@/types/api/FeatureFlag/FeatureFlag';
import { defineStore } from 'pinia';

export const featureFlagDefaultValue: FeatureFlag = {
    EnableProjectList: false,
    EnableCreateProjectFromTemplate: false,
    EnableOrderWorfklow: false,
    EnableTemplateList: false,
    EnableTemplateUpload: false,
    EnableConfiguratorOrder: false,
}

export const useFeatureFlagStore = defineStore('featureFlagStore', {
    state: () => ({
        featureFlag: featureFlagDefaultValue,
        fetchingFeatureFlag: false
    }),
    actions: {
        setFetchingFeatureFlag(fetchingFeatureFlag: boolean) {
            this.fetchingFeatureFlag = fetchingFeatureFlag;
        },
        setFeatureFlags(featureFlag: FeatureFlag) {
            this.featureFlag = featureFlag;
        },
        isProjectListEnabled() {
            return this.featureFlag.EnableProjectList
        },
        isCreateProjectFromTemplateEnabled() {
            return this.featureFlag.EnableCreateProjectFromTemplate
        },
        isOrderWorkflowEnabled() {
            return this.featureFlag.EnableOrderWorfklow
        },
        isTemplateListEnabled() {
            return this.featureFlag.EnableTemplateList
        },
        isTemplateUploadEnabled() {
            return this.featureFlag.EnableTemplateUpload
        },
        isConfiguratorOrderEnabled() {
            return this.featureFlag.EnableConfiguratorOrder
        },
    },
});


export type UseFeatureFlagStore = ReturnType<typeof useFeatureFlagStore>;